import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Grid,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	FormHelperText
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	selectGrid: {
		marginTop: theme.spacing(2)
	},

	selectItem: {
		width: "90%"
	},

	fullWidth: {
		width: "100%"
	}
}));

function SubNavigationSelect(props) {
	let classes = styles(),
		{value, changeHandler, items, title, helperText, id} = props,
		accessToMany = items.filter(item => item.hasAccess || item.hasAccess == null).length > 1;

	return accessToMany ? (
		<Grid container justify="center" className={classes.selectGrid} id={id}>
			<Grid item className={classes.selectItem}>
				<FormControl className={classes.fullWidth}>
					<InputLabel id="subnav-select-label" style={{visibility: "hidden"}}>{title}</InputLabel>
					<Select
						labelId="subnav-select-label"
						id="subnav-select-field"
						variant="outlined"
						value={value}
						onChange={(event) => changeHandler(event, event.target.value)}
						className={classes.fullWidth}>
						{items.map(item =>
							item.hasAccess || item.hasAccess == null ? <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem> : null
						)}
					</Select>
					<FormHelperText>{helperText}</FormHelperText>
				</FormControl>
			</Grid>
		</Grid>
	) : null;
}

SubNavigationSelect.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	changeHandler: PropTypes.func.isRequired,
	items: PropTypes.array,
	title: PropTypes.string,
	helperText: PropTypes.string,
	id: PropTypes.string
};

export default SubNavigationSelect;